module.exports = __webpack_public_path__ + "img/icon_free.8d262b4b.png";